import { gql } from '@apollo/client';

import { StudentPracticeSession } from '@ts-core/modules/practice/types';
import { studentFinishedPracticeSessionFragment } from '@ts-core/modules/practice/graphql/fragments';

export interface GetStudentPracticeSessionQueryVariables {
  courseId: string;
  studentId: string;
  practiceSessionId: string;
}

export interface GetStudentPracticeSessionQueryResult {
  studentPracticeSession: StudentPracticeSession;
}

export const getStudentPracticeSessionQuery = gql`
  query GetStudentPracticeSessionQuery($courseId: String!, $studentId: String!, $practiceSessionId: String!) {
    studentPracticeSession(courseId: $courseId, studentId: $studentId, practiceSessionId: $practiceSessionId)
      @rest(type: "StudentFinishedPracticeSession", path: "courses/{args.courseId}/students/{args.studentId}/practice/{args.practiceSessionId}") {
      ...StudentFinishedPracticeSession
    }
  }
  ${studentFinishedPracticeSessionFragment}
`;
